import React, { FC, useState } from 'react';
import { Input as AntdInput, Tabs } from 'antd';
import {
  DEFAULT_LANGUAGE,
  Language,
  LANGUAGES,
  LocalizedText,
} from 'apollo/localizedTypes';
import languageLabels from 'utils/i18n/languageLabels';
import styles from './LocalizedTextInput.module.scss';

export interface LocalizedTextInputProps {
  value?: LocalizedText;
  onChange?: (value: LocalizedText) => void;
  placeholder?: string;
}

export const LocalizedTextInput: FC<LocalizedTextInputProps> = ({
  value,
  onChange,
  placeholder,
}: LocalizedTextInputProps) => {
  const [activeLanguage, setActiveLanguage] = useState<Language>(DEFAULT_LANGUAGE);
  const { TabPane } = Tabs;

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      ...value,
      [DEFAULT_LANGUAGE]: value?.[DEFAULT_LANGUAGE] || '',
      [activeLanguage]: event.target.value,
    });
  };

  return (
    <div className={styles.Panel}>
      <Tabs
        className={styles.Tabs}
        activeKey={activeLanguage}
        onChange={(key) => setActiveLanguage(key as Language)}
      >
        {LANGUAGES.map((language) => (
          <TabPane tab={languageLabels[language]} key={language} />
        ))}
      </Tabs>
      <AntdInput
        value={value?.[activeLanguage] || ''}
        onChange={onInputChange}
        placeholder={placeholder}
      />
    </div>
  );
};

LocalizedTextInput.defaultProps = {
  value: undefined,
  onChange: undefined,
  placeholder: undefined,
};

export default LocalizedTextInput;
